import PropTypes from 'prop-types';
import React from 'react';
import { debounce } from '../../common/js/utilities.ts';
import Tooltip from '../tooltip/tooltip.jsx';
import Button from './button.jsx';
import CheckboxButton from './checkboxbutton.jsx';

/**
  A button that will conditionally render its children based on the width of the viewport.
  When collapsed, it renders a tooltip containing the children.
*/
class CollapseButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.setIsCollapsed);
    this.setIsCollapsed();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setIsCollapsed);
  }

  setIsCollapsed = debounce(() => {
    const { collapseAt } = this.props;
    const { isCollapsed } = this.state;

    const nextIsCollapsed = window.matchMedia(`(max-width: ${collapseAt}px)`);
    if (isCollapsed !== nextIsCollapsed.matches) {
      this.setState({ isCollapsed: nextIsCollapsed.matches });
    }
  }, 100);

  render() {
    const { children, isCheckbox } = this.props;
    const { isCollapsed } = this.state;
    const thisChildren = isCollapsed ? null : children;
    const button = isCheckbox ? (
      <CheckboxButton {...this.props}>{thisChildren}</CheckboxButton>
    ) : (
      <Button {...this.props}>{thisChildren}</Button>
    );
    return isCollapsed ? (
      <Tooltip block content={children} small>
        {button}
      </Tooltip>
    ) : (
      button
    );
  }
}

CollapseButton.propTypes = {
  /**
   * Children to render
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  /**
    Viewports smaller than this width will show the collapsed button
  */
  collapseAt: PropTypes.number.isRequired,
  /**
    Renders as a checkbox button
  */
  isCheckbox: PropTypes.bool,
};

CollapseButton.defaultProps = {
  isCheckbox: false,
  children: null,
};

export default CollapseButton;
